import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';

const FullScreenLoader = ({ 
  loading = false, 
  message = "Loading...", 
  size = 40 
}) => {
  if (!loading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000000, // Increased z-index to be above SettingsDrawer (1300) and other components
      }}
    >
      <CircularProgress size={size} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {message}
      </Typography>
    </Box>
  );
};

FullScreenLoader.propTypes = {
  loading: PropTypes.bool,
  message: PropTypes.string,
  size: PropTypes.number
};

export default FullScreenLoader;
